import React,{useState,useEffect,useRef} from 'react'
import { Box,Typography,TextField,Button,FormLabel,Link,Modal, InputAdornment,MenuItem,Select,IconButton,RadioGroup,Radio,FormControlLabel,FormControl} from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import backGround from '../assets/giphy4.gif'
import CloseIcon from '@mui/icons-material/Close';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Info from '../pages/Info'
// import {VoiceList} from '../components/VoiceList'



const iconButtonStyle={
  color:'#fff',
  ":disabled":{
    color:'#666'
  },

  
}

const iconStyle={
  fontSize:{xs:24,md:34}
}
const plainText={
  fontSize:{xs:20,md:24}
}

const selectStyle={
  width: {xs:'70%',sm: '50%',md:'40%',lg:'30%'},
  
  color: 'primary.light',
  "& .MuiSvgIcon-root": {
    color: "white",
},
  'label + &': {
    marginTop: 0,
    // color: 'white'
  },
  '& .MuiInputBase-input': {
    borderRadius: 1,
    // position: 'relative',
    backgroundColor: 'rgba(1,1,1,0.7)',
    color: 'white',
    border: 2,
    borderColor:'primary.main',
    fontSize: 16,
    // padding: '10px 26px 10px 12px',
    
    // transition: theme.transitions.create(['border-color', 'box-shadow']),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      
    ].join(','),
    '&:focus': {
      
      borderColor: 'primary.main',
      // boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },}


const scrollBar = {
  '&::-webkit-scrollbar': {
    width: '0.5em'
  },
  '&::-webkit-scrollbar-track': {
    '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)'
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'primary.main',
    borderRadius: 8
    
  },
  '&::-webkit-scrollbar-thumb:hover': {
      backgroundColor: 'rgba(0,0,0,.4)',
      
    }
  }

  let textFieldStyle={
    '& .MuiOutlinedInput-root.Mui-focused':{
      '& fieldset': {
        borderColor: 'primary.light',
      },
    },
    '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: '#555',
    },
    '&:hover fieldset': {
      borderColor: 'primary.light',
    },
    '&:focused fieldset': {
      borderColor: 'primary.light',
    },
    "& label.Mui-focused": {
      color: 'primary.light'
    },
  },
  input:{color: '#fff',...plainText}
}



const Home = ({meditationPage}) => {
  const [ourText, setOurText] = useState('Welcome to your guided meditation')
  const msg = new SpeechSynthesisUtterance()
  const [win,setWin] = useState(window.speechSynthesis)
  const [voices,setVoices]=useState([])
  const [voiceList,setVoiceList] = useState([{name:'No voices available'}])
  const [voice,setVoice]= useState()
  const [voiceT,setVoiceT]= useState()
  const [mins,setMins]= useState(1)
  const [interval,setInterval]=useState(0)
  const [infoOpen,setInfoOpen]=useState(false)
  

  const[mantras,setMantras]=useState(localStorage.getItem('mantras')?JSON.parse(localStorage.getItem('mantras')):[""]);
  const[mantraNum,setMantraNum]=useState(1);
  const mantraRef=useRef()

  const speechHandler = (msg,v) => {
    msg.text = ourText
    msg.voice=voiceList[v]
    console.log(voiceList[v])
    setVoiceT(voiceList[v].name)
    msg.rate=0.85
    // console.log(SpeechSynthesisVoice(VoiceList[v]))
    win.speak(msg)
    
  }

  const handleVoiceSelect = (event) => {
    setVoice(event.target.value);
    // speechHandler(msg,event.target.value)
  };

 

  useEffect(() => {
    if('onvoiceschanged' in win){
      win.addEventListener('voiceschanged', () => {
      const voices = win.getVoices();
    
        setVoiceList(voices)
        setVoices(true)
       
    });
    }
    else{
      setVoiceList(win.getVoices())
        setVoices(true)
    }

 
    
  },[])



  useEffect(() => {
    localStorage.setItem('mantras',JSON.stringify(mantras))
    // console.log(mantras)
    
  },[mantras])

  useEffect(() => {
    // console.log(voice)
    voice!=null&&speechHandler(msg,voice)
    
  },[voice])

  useEffect(() => {
    // console.log(win.getVoices())
    // console.log(list)
    setVoiceList(win.getVoices().length>1?win.getVoices():[])
    
  },[voices])

  const handleMantras = (event,i) => {
    // setMantras(event.target.value);
    setMantras([...mantras.slice(0,i),event.target.value,...mantras.slice(i+1,mantras.length)])
  };
  const handleMantrasDel = (event,i) => {
    // setMantras(event.target.value);
    setMantras([...mantras.slice(0,i),...mantras.slice(i+1,mantras.length)])
  };

  const handleMantrasEnter = (event) => {
    // setMantras(event.target.value);
    if(event.key==='Enter'){
    mantras[mantras.length-1]!=""&&setMantras([...mantras,""])
  }
  };
  

  return (
    <Box height={'100vh'} display={'flex'} flexDirection='column' py={{xs:4,md:8}} px={{xs:2,md:16}} sx={{color:'primary.light',backgroundColor:'black',backgroundImage:`url(${backGround})`,backgroundRepeat:'no-repeat',backgroundPosition:'center', backgroundSize:{xs:'135%',md:'70%'}}}>
        <Typography variant='h1' fontSize={{xs:28,md:44}} align="center">Your Own Guided Meditation</Typography>
        <Box display='flex' justifyContent="center">
          <IconButton sx={{pt:1,...iconButtonStyle}} onClick={()=>setInfoOpen(true)}><InfoOutlinedIcon sx={iconStyle}/></IconButton>
          <Modal
        open={infoOpen}
        onClose={()=>setInfoOpen(false)}
        // aria-labelledby="modal-modal-title"
        // aria-describedby="modal-modal-description"

      >
        <Info/>
      </Modal>
        </Box>
        <Box>
            <Box overflow='auto' p={3} px={{xs:2,md:8}} my={4} backgroundColor='rgba(0,0,0,0.6)' sx={scrollBar} borderRadius={2} border={1}  height={{xs:'20vh',md:'30vh'}} gap={2} alignItems='center' display="flex" flexDirection='column'>
            <Typography variant='h2' fontSize={{xs:20,md:32}}>Mantras/quotes</Typography>
            {mantras.map((m,i)=>(
                <Box display='flex' width='100%'>
                    <TextField  autoFocus  value={m} key={i}
                    InputProps={{
                      endAdornment: (
                        <IconButton sx={iconButtonStyle} disabled={mantras.length==1} onClick={(e)=>handleMantrasDel(e,i)}><CloseIcon sx={iconStyle}/></IconButton>
                      ),
                    }}
                    sx={{...textFieldStyle,width:'100%',pr:0}} onChange={(e)=>handleMantras(e,i)} onKeyDown={handleMantrasEnter}></TextField> 
                    
                </Box>
                
            ))}
            
            <IconButton sx={iconButtonStyle} disabled={mantras[mantras.length-1]==""} onClick={()=>{setMantras([...mantras,""])}}><AddIcon sx={iconStyle}/></IconButton>
            </Box>
            <Box py={{xs:1,md:2}}>
                    <Typography sx={plainText}>Length of meditation:</Typography>
                    <Box display="flex" alignItems="center" my={1} gap={1}>
                      <Box border={1} backgroundColor='rgba(0,0,0,0.6)' borderRadius={2} p={1} gap={2} display="flex" alignItems="center">
                        <IconButton sx={iconButtonStyle} disabled={mins<=1} onClick={()=>{setMins(mins-1)}}> <RemoveIcon sx={iconStyle} /></IconButton>
                        {/* <TextField value={mins} onChange={(e)=>{setMins(e.target.value)}}/>
                        <Typography>mins</Typography> */}
                        <Typography variant='h6' sx={plainText}>{mins}</Typography>
                        <IconButton sx={iconButtonStyle} onClick={()=>{setMins(mins+1)}}>
                        <AddIcon sx={iconStyle}/>
                        </IconButton>
                        </Box>
                        <Typography sx={plainText}>minutes</Typography>
                    </Box>
                </Box>
            <Box py={{xs:1,md:2}} >
              <Typography sx={plainText}>Mantra Interval:</Typography>
              
              <Box display="flex" my={1} alignItems='center' gap={1}>
              <Typography sx={plainText}>Every </Typography>

              <Box border={1} borderRadius={2}  backgroundColor='rgba(0,0,0,0.6)' display='flex' p={1} gap={2} alignItems='center'>
              
                        {/* <TextField value={mins} onChange={(e)=>{setMins(e.target.value)}}/>
                        <Typography>mins</Typography> */}
                        <IconButton sx={iconButtonStyle} disabled={interval<1} onClick={()=>{setInterval(interval-1)}}>
                        <RemoveIcon sx={iconStyle}/>
                        </IconButton>
                        <Typography sx={plainText} align='center' variant='h6'>{interval>0?interval:"30"}</Typography>
                        
                        <IconButton sx={iconButtonStyle}  onClick={()=>{setInterval(interval+1)}}>
                        <AddIcon sx={iconStyle}/>
                        </IconButton>
                        </Box>
                        <Typography sx={plainText}>{interval>0?'minutes':'seconds'}</Typography>
                
              </Box>
              </Box>
        </Box>
        

                

        <Box  
        // border={0} backgroundColor='rgba(0,0,0,0.6)' borderRadius={2} 
        my={2} p={2} display='flex' justifyContent="center" alignItems='center' flexDirection='column'>
            
            {/* <FormControl>
            <FormLabel ><Typography  color='primary.light'>Voice:</Typography></FormLabel>

            
            <RadioGroup  row value={voice} onChange={handleVoiceSelect}>
            <Box display='flex' flexWrap='wrap' px={{xs:2,md:4}} justifyContent='space-around'>
            
              {voiceList.map((i,k)=>(
              <FormControlLabel value={k} control={<Radio sx={{color: 'primary.main'}}/>} label={i.name} />
              ))}
            
            
            </Box>
            </RadioGroup>
            
            
            </FormControl> */}

<Typography sx={{pb:1,width: {xs:'70%',sm: '50%',md:'40%',lg:'30%'},...plainText}}>Voice: </Typography>
<Select
// color='primary.light'
  sx={selectStyle}
    
    value={voiceT}
    
    onChange={(event) => {setVoice(event.target.value)}}
    
  >
    {
     voiceList?(
      voiceList.map((i,k) => (
          <MenuItem key={k} value={k}>
            {i.name}
          </MenuItem>
        ))):(
          <Typography align='center' sx={{fontSize:{xs:18,md:20}}}>No alternate voices available</Typography>
        )
       
        }
  </Select>
  <Typography variant='body2' sx={{fontSize:{xs:18,md:20},mt:1}}>Some devices can only use the voice selected in settings</Typography>
            
        </Box>
  
        <Box display='flex'  flexDirection='column' 
      height='100%' justifyContent='flex-end' py={4}
      // backgroundColor='primary.main'
        // position='absolute'  width='100%' bottom='0%'  
    >
  <Box display="flex" justifyContent='center' >

    <Button variant='contained'
     sx={{
      width:{xs:'85%',sm:'50%',md:'30%'},
      fontSize:22,'&:hover':{backgroundColor:'primary.mainDark'}}}
      onClick={()=>{meditationPage(mantras,voice,mins*60,interval)}}>Start Meditation</Button>
    
  </Box>

  <Box display='flex' justifyContent='center' pt={8}>
    <Typography color='primary.main' as={Link} align='center' rel="noopener" href={'https://shanka.tech/'} target='_blank' sx={{textDecoration:'underline'}}>Created by Shanka</Typography>
    
  </Box>
</Box>
      
    </Box>
  )
}

export default Home